/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    OperationTypeEnum,
    OperationTypeEnumFromJSON,
    OperationTypeEnumFromJSONTyped,
    OperationTypeEnumToJSON,
} from './OperationTypeEnum';
import {
    PersonalAssetHistoryInputTypeEnum,
    PersonalAssetHistoryInputTypeEnumFromJSON,
    PersonalAssetHistoryInputTypeEnumFromJSONTyped,
    PersonalAssetHistoryInputTypeEnumToJSON,
} from './PersonalAssetHistoryInputTypeEnum';
import {
    PersonalAssetHistoryMetaDataDto,
    PersonalAssetHistoryMetaDataDtoFromJSON,
    PersonalAssetHistoryMetaDataDtoFromJSONTyped,
    PersonalAssetHistoryMetaDataDtoToJSON,
} from './PersonalAssetHistoryMetaDataDto';

/**
 * 
 * @export
 * @interface CreatePersonalAssetHistoryDto
 */
export interface CreatePersonalAssetHistoryDto {
    /**
     * 
     * @type {PersonalAssetHistoryMetaDataDto}
     * @memberof CreatePersonalAssetHistoryDto
     */
    metaData?: PersonalAssetHistoryMetaDataDto;
    /**
     * 
     * @type {OperationTypeEnum}
     * @memberof CreatePersonalAssetHistoryDto
     */
    operationType: OperationTypeEnum | null;
    /**
     * 
     * @type {PersonalAssetHistoryInputTypeEnum}
     * @memberof CreatePersonalAssetHistoryDto
     */
    inputType: PersonalAssetHistoryInputTypeEnum | null;
    /**
     * 
     * @type {number}
     * @memberof CreatePersonalAssetHistoryDto
     */
    value: number;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonalAssetHistoryDto
     */
    note?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonalAssetHistoryDto
     */
    personalAssetId: string;
    /**
     * 
     * @type {Date}
     * @memberof CreatePersonalAssetHistoryDto
     */
    date: Date;
}

export function CreatePersonalAssetHistoryDtoFromJSON(json: any): CreatePersonalAssetHistoryDto {
    return CreatePersonalAssetHistoryDtoFromJSONTyped(json, false);
}

export function CreatePersonalAssetHistoryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePersonalAssetHistoryDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'metaData': !exists(json, 'metaData') ? undefined : PersonalAssetHistoryMetaDataDtoFromJSON(json['metaData']),
        'operationType': OperationTypeEnumFromJSON(json['operationType']),
        'inputType': PersonalAssetHistoryInputTypeEnumFromJSON(json['inputType']),
        'value': json['value'],
        'note': !exists(json, 'note') ? undefined : json['note'],
        'personalAssetId': json['personalAssetId'],
        'date': (new Date(json['date'])),
    };
}

export function CreatePersonalAssetHistoryDtoToJSON(value?: CreatePersonalAssetHistoryDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'metaData': PersonalAssetHistoryMetaDataDtoToJSON(value.metaData),
        'operationType': OperationTypeEnumToJSON(value.operationType),
        'inputType': PersonalAssetHistoryInputTypeEnumToJSON(value.inputType),
        'value': value.value,
        'note': value.note,
        'personalAssetId': value.personalAssetId,
        'date': (value.date.toISOString()),
    };
}

